export default class Utils {
    static validarCampo(name, value, valorDependiente) {
      switch (name) {
        case "nombres":
        case "apellidos":
          return !value || Utils.validarNombres(value);
        case "correo":
          return !value || Utils.validarEmail(value);
        case "codigoCorredor":
          return !value || Utils.validarNumeroPositivos(value);
        case "fileUrl":
          return (
            !value ||
            Utils.validarArchivoCargaMasiva(value, "csv", valorDependiente)
          );
        case "codigoProducto":
          return Utils.validarNumero(value);
        case "nombreAtributo": {
          if (valorDependiente) {
            if (valorDependiente == "String")
              return (
                !value ||
                (Utils.validarAlfanumerico(value) &&
                  Utils.validarLongitudMax(value, 15))
              );
            if (valorDependiente == "Number")
              return (
                !value ||
                (Utils.validarNumero(value) &&
                  Utils.validarLongitudMax(value, 15))
              );
          } else {
            return (
              !value ||
              (Utils.validarAlfanumerico(value) &&
                Utils.validarLongitudMax(value, 15))
            );
          }
        }
        case "nombreSubAtributo": {
          return (
            !value ||
            (Utils.validarAlfanumerico(value) &&
              Utils.validarLongitudMax(value, 100))
          );
        }
        default: {
          if (valorDependiente) {
            if (valorDependiente == "String")
              return (
                !value ||
                (Utils.validarAlfanumerico(value) &&
                  Utils.validarLongitudMax(value, 50))
              );
            if (valorDependiente == "Number")
              return (
                !value ||
                (Utils.validarNumero(value) &&
                  Utils.validarLongitudMax(value, 50))
              );
          } else {
            return true;
          }
        }
      }
    }
  
    static validarNull(value) {
      if (
        value === undefined ||
        value === null ||
        value.length === 0 ||
        value === ""
      ) {
        return false;
      }
      return true;
    }
  
    static validarNumero(value) {
      let regExp = /^[0-9]+$/;
  
      return Utils.validarNull(value) ? regExp.test(value) : false;
    }
  
    static validarTelefono(value) {
      let regExp = /^[0-9]+$/;
  
      return Utils.validarNull(value)
        ? regExp.test(value) && value.length > 6 && value.length < 10
        : false;
    }
  
    static validarUsername(name, value, minlength) {
      let resp = {};
      let valnumber = Utils.validarNumero(value);
      let valrangomin = Utils.validarLongitudMin(value, minlength);
  
      if (valnumber) {
        if (valrangomin) {
          resp.validate = true;
          resp.msj = "";
        } else {
          resp.validate = false;
          resp.msj =
            "El campo " +
            name +
            " debe contener por lo menos " +
            minlength +
            " caracteres";
        }
      } else {
        resp.validate = false;
        resp.msj = "El campo " + name + " solo permite números";
      }
  
      return resp;
    }
  
    static validarPass(name, value, minlength) {
      let resp = {};
      let valrangomin = Utils.validarLongitudMin(value, minlength);
  
      if (valrangomin) {
        resp.validate = true;
        resp.msj = "";
      } else {
        resp.validate = false;
        resp.msj =
          "El campo " +
          name +
          " debe contener por lo menos " +
          minlength +
          " caracteres";
      }
  
      return resp;
    }
  
    static validarLongitud(value, minlength, maxlength) {
      if (value === undefined || value === null || value.length === 0) {
        return false;
      } else {
        if (value.length >= minlength && value.length <= maxlength) {
          return true;
        } else {
          return false;
        }
      }
    }
  
    static validarLongitudMin(value, minlength) {
      if (value === undefined || value === null || value.length === 0) {
        return false;
      } else {
        if (value.length >= minlength) {
          return true;
        } else {
          return false;
        }
      }
    }
  
    static validarLongitudMax(value, maxlength) {
      if (value === undefined || value === null || value.length === 0) {
        return false;
      } else {
        if (value.length <= maxlength) {
          return true;
        } else {
          return false;
        }
      }
    }
  
    static validarComentarios(value) {
      let regExp = /^[+]?([0-9]+(?:[0-9]*)?|[0-9]+)$/;
      return Utils.validarNull(value) ? !regExp.test(value) : false;
    }
  
    static validarNombres(value) {
      let regExp = /^([A-Za-z]+\s?)*$/;
      return Utils.validarNull(value) ? regExp.test(value) : false;
    }
  
    static validarNumeroPositivos(value) {
      let regExp = /^[0-9]*$/;
  
      return Utils.validarNull(value) ? regExp.test(value) && value > 0 : false;
    }
  
    static validarArchivoCargaMasiva(value, type, file) {
      let regExp = /\.[0-9a-z]+$/;
      let valExtension = Utils.validarNull(value)
        ? value.match(regExp)[0] == "." + type
        : false;
      let valTamanio = Utils.validarNull(value) ? file.size <= 3000 : false;
      return valExtension && valTamanio;
    }
  
    static validarNumeroDecimal(value) {
      let regExp = /^[0-9]*(.[0-9]+)?$/;
  
      return Utils.validarNull(value) ? regExp.test(value) && value > 0 : false;
    }
  
    static validarEmail(value) {
      let regExp =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
      return Utils.validarNull(value) ? regExp.test(value) : false;
    }
  
    static validarSoloTexto(value) {
      let regExp = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/;
  
      return Utils.validarNull(value) ? regExp.test(value) : false;
    }
  
    static validarAlfanumerico(value) {
      //let regExp = /^([0-9A-Za-záÁéÉíÍóÓúÚ&\-]+\s?)*$/
      let regExp =
        /^([0-9A-Za-záÁéÉíÍóÓúÚ&\-]+\s?)*([0-9A-Za-záÁéÉíÍóÓúÚ&\-]+)+$/;
  
      return Utils.validarNull(value) ? regExp.test(value) : false;
    }
  
    static validarDocumento(numeroDocumento, idpTipoDocumento) {
      switch (idpTipoDocumento) {
        case 1: //RUC
          if (
            Utils.validarNumero(numeroDocumento) &&
            numeroDocumento.length === 11
          ) {
            return true;
          } else {
            return false;
          }
        case 2: //DNI
          if (
            Utils.validarNumero(numeroDocumento) &&
            numeroDocumento.length === 8
          ) {
            return true;
          } else {
            return false;
          }
        default:
          return true;
      }
    }
  
    static validarFormState(state, tipo) {
      var result = true;
      var arrayKeys = Object.keys(state).filter((key) => {
        return key.indexOf("v_", 0) !== -1;
      });
  
      arrayKeys.forEach((key) => {
        if ("formulario" === tipo) {
          result = result && state[key];
        } else if ("filtro" === tipo) {
          result = result || state[key];
        } else {
          result = result && state[key];
        }
      });
      return result;
    }
  
    static convertirMayusculas(value) {
      let upperValue = value.toUpperCase();
      return upperValue;
    }
  
    static convertirMinusculas(value) {
      let lowerValue = value.toLowerCase();
      return lowerValue;
    }
  
    static soloNumeros(event) {
      let { value } = event.target;
      let regExp = /^[0-9]+$/;
  
      return regExp.test(value);
    }
  
    static isMobile() {
      return {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
          return (
            this.Android() ||
            this.BlackBerry() ||
            this.iOS() ||
            this.Opera() ||
            this.Windows()
          );
        },
      };
    }
  
    static getLocalStorageValueForRegex(regex) {
      var resp;
      Object.keys(localStorage).forEach(function (key) {
        if (regex.test(key)) {
          resp = localStorage.getItem(key);
        }
      });
      return resp;
    }
  
    static getLocalStorageValueGuess() {
      let resp = JSON.parse(localStorage.getItem("credentialGuess"));
      return resp;
  
      
    }
  
    static validarPermisosXPath(path) {
      var ind = false;
      if (path) {
        var permisos = JSON.parse(localStorage.getItem("permisos"));
        for (var i = 0; i < permisos.length; i++) {
          if (permisos[i].path == path) {
            ind = true;
            break;
          } else if (permisos[i].path == "") {
            for (var j = 0; j < permisos[i].submenu.length; j++) {
              if (permisos[i].submenu[j].path == path) {
                ind = true;
                break;
              }
            }
            if (ind) break;
          }
        }
      }
      return ind;
    }
  
    static async readFile(file) {
      return new Promise((resolve, reject) => {
        try {
          let reader = new FileReader();
          reader.onload = (e) => {
            resolve(reader.result);
          };
          reader.readAsArrayBuffer(file);
        } catch (err) {
          reject(err);
        }
      });
    }
  
    static generarCodigoAtributo(listaAtributos) {
      let codigo =
        listaAtributos && listaAtributos.length > 0
          ? listaAtributos.slice(-1).pop().code
          : "A00";
      return "A" + String(parseInt(codigo.substring(1, 3)) + 1).padStart(2, "0");
    }
  }
  